const getTourQuoteKey = ({ date, rangeDays, slotDescription, rateQuantities, currency }) =>
  JSON.stringify({
    date: date || '',
    rangeDays: rangeDays || 0,
    slotDescription: slotDescription || '',
    currency: currency || '',
    rates: Object.entries(rateQuantities || {}).sort(([left], [right]) => (left < right ? -1 : 1)),
  });

export default getTourQuoteKey;
